import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { HelpersService } from '../services/helpers.service';

@Injectable()
export class RoleGuard implements CanActivate {
    constructor(private helpersService: HelpersService,
                private router: Router) {}


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.helpersService.user) {
            if (this.canRoute(route)) {
                return of(true);
            } else {
                this.redirect();
                return of(false);
            }
        } else {
            return of(false);
        }

    }

    private redirect(): void {
        this.router.navigateByUrl('/unauthorized');
    }

    private canRoute(route: ActivatedRouteSnapshot): boolean {
        const can =  this.helpersService.checkRole(route.data.requiredRole);
        return can;
    }
}
